<script>
  import TumbleWeed from './TumbleWeed.svelte';
  import "../scss/tumbleweed.scss";
</script>

<div class="desert">
  <TumbleWeed />
  <TumbleWeed />
</div>
